import React from 'react';
import '../../css/ThankYouPopup.css';

function ThankYouPopup({ message}) {
    return (
        <div className="thank-you-popup-container">
            <div className="thank-you-popup-wrap">
                <div className="thank-you-popup-title">
                    {message}
                </div>
            </div>
        </div>
    );
}

export default ThankYouPopup;
